import { templateThemeTokens } from './templateThemeTokens.js';
import { fontStacks } from '@/stitches/fonts.js';
import { createTheme } from '@/stitches/index.js';
import { merge } from 'lodash-es';

const mergedTokens = merge(templateThemeTokens, {
  colors: {
    defaultFont: '$white',
    pageBackground: '#6A57E3',
  },
  fonts: {
    body: fontStacks.satoshi.value,
    heading: fontStacks.zodiak.value,
  },
});

export const dusk = createTheme({ ...mergedTokens });
